import { useLazyQuery } from "@apollo/client";
import { searchQuery } from "GraphQL/queries/dashboard";
import { get, uniqBy } from "lodash";
import { FETCH_POLICY } from "src/constants";
import LearningCheckinNotificaionIcon from "Assets/images/learning-notification-icon.svg";
import SurveyCheckinNotificaionIcon from "Assets/images/survey-checkin-notification-icon.svg";
import SkillRatingCheckinNotificaionIcon from "Assets/images/skillrating-checkin-notification-icon.svg";
import RequestFeedbackNotificationIcon from "Assets/images/request-feedback-search-icon.svg";
import {
  inputEventState,
  searchOptionsState,
  variablesState,
} from "Recoil/General/atom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { anchorElState } from "Recoil/Checkins/atom";

export const searchBar = () => {
  const [searchOption, setSearchOptions] = useRecoilState(searchOptionsState);
  const setAnchorEl = useSetRecoilState(anchorElState);
  const inputEvent = useRecoilValue(inputEventState);
  const [variablesData, setVariablesData] = useRecoilState(variablesState);
  const searchData = (variables) => {
    searchQueryData(variables);
    setVariablesData(variables);
  };
  const [searchQueryData, { loading }] = useLazyQuery(searchQuery, {
    fetchPolicy: FETCH_POLICY.networkOnly,
    onCompleted: (data) => {
      const nextToken = {
        userNextToken: data?.getCompany?.users?.nextToken,
        targetNextToken: data?.listTargetCustom?.items?.nextToken,
      };
      const userData = get(data, "getCompany.users.items", []);
      const targetData = get(
        data,
        "getCompany.listTargetCustom.items.0.targets",
        []
      );
      const checkinData = get(data, "getCompany.checkinSearch.items", []);
      const SSorPRData = get(data, "getCompany.successStorySearch.items", []);
      const userSearchResult = [
        ...userData.map((user) => {
          return {
            ...user,
            type: "User",
            id: get(user, "id", ""),
            image: get(user, "profileImage.fileName", ""),
            name: `${get(user, "firstName", "")} ${get(user, "lastName", "")} ${
              user?.status === "PENDING" ? "(Pending)" : ""
            }`,
            status: user?.status,
          };
        }),
        ...searchOption.filter((res) => res?.type === "User"),
      ];
      const targetSearchResult = [
        ...targetData.map((target) => {
          return {
            type: "Target",
            id: get(target, "id", ""),
            image: `${
              (get(target, "logo.fileName", "") || "").length
                ? `${process.env.REACT_APP_CLOUD_FRONT_URL}/${get(
                    target,
                    "logo.fileName",
                    ""
                  )}`
                : ""
            }`,
            name: get(target, "title", ""),
          };
        }),
        ...searchOption.filter((res) => res?.type === "Target"),
      ];
      const successStorySearchResult = [
        ...SSorPRData.map((ssorpr) => {
          return {
            type: "SuccessStory",
            id: get(ssorpr, "id", ""),
            name: get(ssorpr, "title", ""),
            isPerformanceReview: get(ssorpr, "isPerformanceReview", ""),
          };
        }),
        ...searchOption.filter((res) => res?.type === "SuccessStory"),
      ];
      const checkinSearchResult = [
        ...checkinData.map((checkin) => {
          let image = "";
          const type = get(checkin, "checkInType", "");
          switch (type) {
            case "LEARNING":
              image = LearningCheckinNotificaionIcon;
              break;
            case "SURVEY":
              image = SurveyCheckinNotificaionIcon;
              break;
            case "SKILLRATING":
              image = SkillRatingCheckinNotificaionIcon;
              break;
            case "REQUESTFEEDBACK":
              image = RequestFeedbackNotificationIcon;
            default:
              break;
          }
          return {
            type: "Checkin",
            id: get(checkin, "id", ""),
            image,
            name: get(checkin, "name", ""),
            targetId: get(checkin, "checkInTargetId", ""),
            showCheckinDetails: checkin?.showCheckinDetails,
          };
        }),
        ...searchOption.filter((res) => res?.type === "Checkin"),
      ];
      setSearchOptions(
        uniqBy(
          [
            ...userSearchResult,
            ...targetSearchResult,
            ...checkinSearchResult,
            ...successStorySearchResult,
          ],
          "id"
        )
      );
      setAnchorEl(inputEvent);
      if (Object.values(nextToken).some((res) => res)) {
        searchQueryData({
          variables: { ...variablesData?.variables, ...nextToken },
        });
      }
    },
  });

  return { loading, searchData };
};
